import { PlusOutlined } from '@ant-design/icons';
import { Button, Card } from 'antd';
import React, { useContext, useState } from 'react';
import { AppContext } from '../../../../../AppContext';
import {
  MODULES,
  PERMISSIONS_KEY,
  PERMISSION_TYPE,
} from '../../../../../common/constants';
import { hasPermission } from '../../../../../common/utils';
import Portal from '../../../../../components/Portal';
import PincodeTable from '../components/PincodeTable';

const Pincode = () => {
  const {
    state: { permissions },
  } = useContext(AppContext);
  const [isPincodeModalOpen, setIsPincodeModalOpen] = useState(false);

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.PINCODE}</div>
      </Portal>
      <Portal portalId="header-right-content">
        {hasPermission(
          PERMISSIONS_KEY?.MASTER_LIST_PINCODE,
          PERMISSION_TYPE?.CREATE,
          permissions,
        ) && (
          <Button
            className="common-button"
            size="middle"
            icon={<PlusOutlined />}
            onClick={() => {
              setIsPincodeModalOpen(true);
            }}
          >
            Add New Pincode
          </Button>
        )}
      </Portal>
      <Portal portalId="header-right-content-phones">
        {hasPermission(
          PERMISSIONS_KEY?.MASTER_LIST_PINCODE,
          PERMISSION_TYPE?.CREATE,
          permissions,
        ) && (
          <Button
            className="common-button"
            size="middle"
            icon={<PlusOutlined />}
            onClick={() => {
              setIsPincodeModalOpen(true);
            }}
          >
            Add New Pincode
          </Button>
        )}
      </Portal>
      <Card className="full-height-without-nav">
        <PincodeTable
          isPincodeModalOpen={isPincodeModalOpen}
          setIsPincodeModalOpen={setIsPincodeModalOpen}
        />
      </Card>
    </>
  );
};

export default Pincode;
